import bcrypt from "bcryptjs";

export default (enteredText, hash) => {
  return bcrypt.compareSync(enteredText, hash);
};
